"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M20 2H4v20h10v-2H6V4h12v6h2V2z"
  }), _react.default.createElement("path", {
    d: "M8 6h8v2H8V6zm5 4H8v2h5v-2zm6.9893 1.9473h-2v1.1185c-.4386.0901-.8177.238-1.1373.4439-.568.3658-.852.9145-.852 1.6461 0 .4429.077.8135.231 1.1119.1541.2888.3899.5391.7076.7509s.722.4188 1.213.621c.5102.2117.8857.385 1.1263.5198.2407.1348.3947.2551.4621.361.077.1059.1155.2262.1155.361 0 .2022-.0914.3658-.2743.491-.1733.1251-.4717.1877-.8953.1877-.3755 0-.8087-.0626-1.2996-.1877-.491-.1252-.9483-.284-1.3719-.4765v1.7761c.3947.1637.7894.2792 1.1841.3466.2361.046.4996.0783.7908.0968V22h2v-1.003c.459-.1054.838-.2715 1.137-.4983.5679-.4332.8519-1.0493.8519-1.8483 0-.4621-.0914-.8424-.2743-1.1408-.1733-.2984-.4236-.5439-.7509-.7365-.3273-.2021-.7172-.3947-1.1697-.5776-.4621-.1925-.8134-.3465-1.0541-.462-.231-.1156-.3899-.2215-.4765-.3177-.077-.1059-.1156-.2214-.1156-.3466 0-.3466.3177-.5198.9531-.5198.3562 0 .7076.0577 1.0541.1732.3466.1059.7124.2407 1.0975.4044l.6498-1.5451c-.4717-.2215-.929-.3803-1.3718-.4766a6.1447 6.1447 0 0 0-.5305-.0908v-1.0672z"
  })];
};

exports.default = _default;